import { AnswerPart, AnswerPartResponse, AnswerPartStandalone } from "../../../react/CalcPad/apimodels/AnswerPart";
import { GetAssignmentRequest, GetAssignmentResponse } from "../../../react/CalcPad/apimodels/DisplayAssignment";
import { PreviewProblemRequest, PreviewProblemResponse } from "../../../react/CalcPad/apimodels/PreviewProblem";
import { CPReactMethods } from "../../../react/CalcPad/app";
import { AjaxHelper } from "../../SharedLibrary/AjaxHelper";

// declare so we can reference the methods without importing the ACTUAL class.
declare global {
    interface Window {
        CPReactMethods: CPReactMethods
    }
}

export class CPMethods {

    public launchAssignment(container: HTMLDivElement, taskEntityPartCodename: string): void {
        const ajax = new AjaxHelper();
        window.toasts = window.GlobalMethods.AddToast(window.toasts, "loadingAssignment", "Loading Assignment");
        window.GlobalMethods.ShowToast(window.toasts, "loadingAssignment")
        // Get Assignment
        let request: GetAssignmentRequest = {
            taskEntityPartCodename
        };
        ajax.postRequest<GetAssignmentResponse>("/api/tasktracker/calcpad/GetAssignment", request)
            .then(response => {
                window.GlobalMethods.HideToast(window.toasts, "loadingAssignment")
                if (!response.successful) {
                    if (response.message.indexOf("Could not find an assignment") > -1) {
                        alert("Could not find an assignment by that code name " + taskEntityPartCodename + ".");
                    } else {
                        alert(response.message);
                    }
                }
                window.CPReactMethods.launchAssignmentDisplay(container, response.data)
            });
    }

    public launchProblem(container: HTMLDivElement, problemGuid: string): Promise<void | PreviewProblemResponse> {
        const ajax = new AjaxHelper();

        // Get Problem
        let request: PreviewProblemRequest = {
            problemGuid: problemGuid
        }
        return ajax.postRequest<PreviewProblemResponse>("/api/tasktracker/calcpad/PreviewProblem", request)
            .then(response => {
                if (!response.successful) {
                    throw new Error(response.message)
                }
                window.CPReactMethods.launchProblemDisplayPublic(container, response.data)
            })
    }

    // Used for Public assignments and also answer teacher's assignment's problem
    public answerPart(problemInstanceId: number, partInstanceId: number, seed: number, answer: number, exponent?: number, courseGuid?: string): Promise<boolean> {
        const ajax = new AjaxHelper();

        // Get Assignment
        let request: AnswerPart = {
            courseGuid,
            problemInstanceId,
            partInstanceId,
            seed,
            answer,
            exponent: exponent ?? 0
        };
        return ajax.postRequest<AnswerPartResponse>("/api/tasktracker/calcpad/AnswerPart", request)
            .then(response => {
                if (!response.successful) {
                    throw new Error(response.message);
                }
                return response.correct;
            });
    }

    // Used for public preview of single problem
    public answerPartStandalone(problemGuid: string, partId: number, seed: number, answer: number, exponent?: number): Promise<AnswerPartResponse> {
        const ajax = new AjaxHelper();

        // Get Assignment
        let request: AnswerPartStandalone = {
            problemGuid,
            partId,
            seed,
            answer,
            exponent: exponent ?? 0
        };
        return ajax.postRequest<AnswerPartResponse>("/api/tasktracker/calcpad/AnswerPartStandalone", request)
            .then(response => {
                if (!response.successful) {
                    throw new Error(response.message);
                }
                return response;
            });
    }
}
